import { Badge, badgeVariants } from '@/components/shadcn/badge'
import type { VariantProps } from 'class-variance-authority'
import { Plus } from 'lucide-react'
import { CopyableSyntaxExample } from './CopyableSyntaxExample'

type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>['variant']>

const VARIANTS: { variant: BadgeVariant; label: string }[] = [
  { variant: 'default', label: 'Primary (default)' },
  { variant: 'secondary', label: 'Secondary' },
  { variant: 'outline', label: 'Outline' },
  { variant: 'ghost', label: 'Ghost' },
  { variant: 'link', label: 'Link' },
  { variant: 'destructive', label: 'Destructive' },
  { variant: 'success', label: 'Success' },
  { variant: 'warning', label: 'Warning' },
  { variant: 'error', label: 'Error' },
  { variant: 'info', label: 'Info' },
]

function formatBadgeSyntax({ variant, children }: { variant: BadgeVariant; children: string }) {
  const attrs = variant === 'default' ? '' : ` variant="${variant}"`
  return `<Badge${attrs}>${children}</Badge>`
}

function VariantRow({ variant, label }: { variant: BadgeVariant; label: string }) {
  return (
    <div className="space-y-3 border-b border-border pb-6 last:border-b-0 last:pb-0">
      <h3 className="text-sm font-semibold">{label}</h3>
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <p className="text-xs text-muted-foreground">Text only</p>
          <CopyableSyntaxExample syntax={formatBadgeSyntax({ variant, children: 'Badge' })}>
            <Badge variant={variant}>Badge</Badge>
          </CopyableSyntaxExample>
        </div>
        <div className="space-y-2">
          <p className="text-xs text-muted-foreground">With icon</p>
          <CopyableSyntaxExample syntax={formatBadgeSyntax({ variant, children: '<Plus />Badge' })}>
            <Badge variant={variant}>
              <Plus />
              Badge
            </Badge>
          </CopyableSyntaxExample>
        </div>
      </div>
    </div>
  )
}

export function BadgesSection() {
  return (
    <div className="space-y-6">
      <p className="text-xs text-muted-foreground">Click any example to copy its JSX.</p>
      {VARIANTS.map((item) => (
        <VariantRow key={item.variant} {...item} />
      ))}
    </div>
  )
}
